import React from 'react'

export const OrganizationHome = () => {
    return <div>OrganizationHome</div>
}
